<form class="fullscreen-dialog" [formGroup]="form">

    <div class="sticky-header">
        <h2 mat-dialog-title class="!flex !items-center">
            <mat-icon class="pointer" (click)="close.emit()">keyboard_arrow_left</mat-icon>

            <span *ngIf="!itemToBeUpdated?.id">
                New location (Countries)
            </span>

            <span *ngIf="itemToBeUpdated?.id">
                Update location (Countries)
                 <button mat-button [matMenuTriggerFor]="menu">
                    <mat-icon color="warn">
                        delete
                    </mat-icon>
                </button>

                <mat-menu #menu="matMenu">

                    <div class="p-4 ">

                        Deleting this named location is a permanent action and cannot be undone.
                    </div>

                    <div class="p-4 flex items-center gap-2">

                        <button mat-raised-button color="warn" (click)="delete()">
                            Delete
                        </button>

                        <button class="mx-2" mat-raised-button>
                            Cancel
                        </button>
                    </div>
                </mat-menu>
            </span>

        </h2>

        <div class="block">
            <mat-label>Name</mat-label>
            <input [class.border-red-500]="form.get('displayName').invalid && form.get('displayName').touched"
                placeholder="Name this location" class="simple-input" formControlName="displayName" />

            <mat-error *ngIf="form.get('displayName').invalid && form.get('displayName').touched" class="">
                <span>Name is required</span>
            </mat-error>
        </div>


        <div class="block">
            <mat-label>Country Lookup Method</mat-label>

            <ng-select [appendTo]="'body'" formControlName="countryLookupMethod" [clearable]="false">
                <ng-option [value]="'clientIpAddress'"> Determine location by IP address (IPv4 and
                    IPv6)</ng-option>
                <ng-option [value]="'authenticatorAppGps'">Determine location by GPS coordinates </ng-option>
            </ng-select>
        </div>

        <div class="block">
            <div class="flex items-center gap-2">
                <mat-checkbox formControlName="includeUnknownCountriesAndRegions">
                    Include unknown countries/regions
                </mat-checkbox>

                <mat-icon size="small"
                    matTooltip="Some IP addresses can't be mapped to a specific country or region. To capture these IP locations, check the box Include unknown countries/regions when defining a geographic location. This option allows you to choose if these IP addresses should be included in the named location. Use this setting when the policy using the named location should apply to unknown locations.">info</mat-icon>
            </div>
        </div>
    </div>

    <div class="countries content">
        <div class="w-full sticky">
            <input placeholder="Search country" class="simple-input" type="search" formControlName="searchText"
                (ngModelChange)="onSearchChange()" />

            <div class="selected-countries">
                <a (click)="sortSelected()">
                    {{form.value.countriesAndRegions.length}} selected
                </a>
            </div>
        </div>

        <!-- Select All -->


        <mat-selection-list #selectAllRef class="select-all">
            <mat-list-option [selected]="isAllSelected()" (click)="toggleSelectAll()">
                <div class="font-bold">Select All</div>
            </mat-list-option>

        </mat-selection-list>

        <mat-selection-list #selectionList formControlName="countriesAndRegions" class="list-options">

            <!-- Actual Country Options -->
            <mat-list-option *ngFor="let item of filteredCountries" [value]="item.code">
                {{ item.name }}
            </mat-list-option>
        </mat-selection-list>

    </div>

    <div class="dialog-footer">
        <button [class.loading-btn]="isCreating" [disabled]="form.invalid" (click)="save()" mat-raised-button
            color="primary">
            Save
        </button>

        <button (click)="close.emit()" mat-raised-button>
            Cancel
        </button>
    </div>
</form>
